import { useGuestDetailLauncher } from "./GuestDetailLauncher";

type Props = {
  guestId?: string | null;
  children: React.ReactNode;
  className?: string;
};

/**
 * Renders a guest name that underlines on hover and opens the guest-detail
 * popup on click. Inline (`<span>`) so it slots into existing truncating
 * name nodes without breaking layout. `stopPropagation` keeps the click from
 * triggering the surrounding draggable card / clickable seat row / select.
 * When no `guestId` is available the name renders as plain, non-interactive
 * text (slotting fallbacks show only a truncated id).
 */
export function GuestNameButton({ guestId, children, className = "" }: Props) {
  const { open } = useGuestDetailLauncher();

  if (!guestId) return <>{children}</>;

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={(e) => {
        e.stopPropagation();
        open(guestId);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation();
          open(guestId);
        }
      }}
      className={`cursor-pointer hover:underline ${className}`}
    >
      {children}
    </span>
  );
}
